import { createSelector } from '@reduxjs/toolkit';

const selectLiveMap = state => state.liveMap;

export const selectShowGeoJsonLayers = createSelector(selectLiveMap, state => state?.showGeoJSONLayers);

export const selectShowAlerts = createSelector(selectLiveMap, state => state?.showAlerts);
